import React from 'react';
import Gestion from 'src/pages/gestion/Gestion';
import {
	Routes, Route,
} from 'react-router-dom';
import IndexAspirantes from 'src/pages/gestion/aspirantes/IndexAspirantes';

function RouterGestion() {
	return (
		<Routes>
			<Route
				path="/"
				element={(
					<Gestion />
				)}
			/>
			<Route
				path="/aspirantes"
				element={(
					<IndexAspirantes />
				)}
			/>
		</Routes>
	);
}

export default RouterGestion;
